module.exports = __webpack_public_path__ + "static/media/confetti_modal.cb576bc7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/virtualEvents/confetti_modal.svg
// module id = 2644
// module chunks = 71